const defaultQuery = {
  limit: 10,
  page: 1,
  sort: ['updatedAt:desc'],
}

export { defaultQuery }
